import { render, staticRenderFns } from "./MyDetail.vue?vue&type=template&id=dfde2a30&scoped=true&"
import script from "./MyDetail.vue?vue&type=script&lang=js&"
export * from "./MyDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyDetail.vue?vue&type=style&index=0&id=dfde2a30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfde2a30",
  null
  
)

export default component.exports